import React, { FC } from 'react';
import { StorageData, useStorage } from '~Components/Storage';
import Toggle from '~ComponentsImproved/Toggle';
import Heading from '~ComponentsImproved/Typography/Heading';
import { useI18n, useLogger } from '~Hooks';
import { SettingsBlock } from '~Scenes/Settings-v2';
import { Box } from '~Styles';

const TablesSettings: FC = () => {
  const { i18n } = useI18n();
  const [storage, commitToStorage, storageLoading] = useStorage();
  const logger = useLogger('settings-v2-tables');

  function updateStorage(data: Partial<StorageData>) {
    logger.info('Updating Settings (Tables Settings)', { fields: data });
    commitToStorage(data);
  }

  const togglesConfig: Array<{
    label: string;
    subLabel?: string;
    key: string;
    storage: any;
    inverted?: boolean;
  }> = [
    {
      label: i18n('Settings.HideCoverageModal.Title'),
      subLabel: i18n('Settings.HideCoverageModal.Description'),
      key: 'hideCoverageModal',
      storage: storage.hideCoverageModal,
    },
    {
      label: i18n('Settings.Tables.ShowSeatingTime'),
      key: 'showSeatingTimeInTSR',
      storage: storage.showSeatingTimeInTSR,
    },
  ];

  if (storageLoading) {
    return null;
  }

  return (
    <Box padding="large">
      <Heading level={4} bottom={8} color="var(--colorWhite)">
        {i18n('Settings.Tables')}
      </Heading>
      <SettingsBlock>
        {togglesConfig.map((toggle) => (
          <Toggle
            key={toggle.key}
            settingKey={toggle.key}
            label={`${toggle.label} ${storage.devMode ? '[' + toggle.key + ']' : ''} `}
            description={toggle.subLabel}
            initialValue={toggle.inverted ? !toggle.storage : toggle.storage}
            onToggle={() => updateStorage({ [toggle.key]: !toggle.storage })}
            fullWidth
            darkBackground
            lightText
          />
        ))}
      </SettingsBlock>
    </Box>
  );
};

export default TablesSettings;
